(ns shared.core.amelia-light.components.pill
  (:require [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.interactive :as interactive]))

(defn pill-button [{:keys [label value selected? on-click]}]
  [interactive/interactive
   :button {:on-click #(on-click value)
            :style {:border-radius 64
                    :border (str "1px solid " (style/alc-color "Border/secondary"))
                    :background-color (if selected?
                                        (style/alc-color "Background/active")
                                        (style/alc-color "Buttons/secondary_normal"))
                    :font-size 12
                    :font-weight 400
                    :line-height 1.4
                    :letter-spacing 0
                    :color (if selected?
                             (style/alc-color "Text/primary_on_bg")
                             (style/alc-color "Text/primary"))
                    :cursor :pointer
                    :outline :none
                    :transition "all 0.2s ease"
                    :white-space :nowrap
                    :padding "6px 20px"
                    :height 28}
            :hover-style (when (and on-click (not selected?))
                           {:opacity 0.9})}
   label])

(defn pill-button-group [{:keys [selected-value options on-change form-path form-name]}]
  (let [form-vals? (and form-path form-name)
        selected-value (or selected-value
                           (when form-vals? @(re/subscribe [:form/val- form-path form-name]))
                           (some-> options (first) :value))]
    (->> options
         (mapv (fn [{:keys [label value]}]
                 [pill-button {:label label
                               :value value
                               :selected? (= selected-value value)
                               :on-click (or on-change
                                             (when form-vals?
                                               #(re/dispatch [:form/change form-path form-name value])))}]))
         (into [:div {:style {:display :flex
                              :gap 6}}]))))
